<template>
  <div>
    <div></div>
    <card :title="`总数量:${this.tableData.length}`">
      <div class="conItem">
        <p class="bianhao">编号</p>
        <p class="gas_name">站点名称</p>
        <p class="price">价格</p>
        <p class="station_price">站点价格</p>
        <p class="retail_prices">价格/零售价</p>
        <p class="apply_status">调价申请</p>
        <p class="apply_action">发起申请</p>
      </div>
      <div v-for="(item,key) in tableData" :key="key" class="conItem">
        <p class="bianhao">{{key + 1}}</p>
        <p class="gas_name">
          <span>{{item.gas_name}}</span>
          <Tag color="orange">{{item.is_bill===1 ? 'A型' : 'B型'}}</Tag>
        </p>
        <p class="price">
          <span>车队价格 : {{item.has_company_price === 1 ? item.company_price : '未设置'}}</span>
        </p>
        <p class="station_price">
          <span>油机价 : {{item.station_price}}</span>
          <span>挂牌价 : {{item.ndrc_price}}</span>
        </p>
        <p class="retail_prices">
          {{item.company_price}} /  {{item.retail_prices}}
        </p>
        <p class="apply_status">
          <Tag :color="getApplyStatusColor(item.partner_apply_status)">{{ item.partner_apply_status_text || '无申请' }}</Tag>
          <span v-if="item.partner_apply_status===1" class="apply_text">{{item.partner_apply_old_price}} -> {{item.partner_apply_new_price}}</span>
          <span v-if="item.partner_apply_status===3 && item.partner_apply_reject_reason" class="apply_text">驳回: {{item.partner_apply_reject_reason}}</span>
        </p>
        <p class="apply_action">
          <Input class="editPriceInput" v-model="item.apply_price" size="small" placeholder="新价格" />
          <Button type="warning" size="small" :disabled="item.has_company_price !== 1 || item.partner_apply_status===1" @click="applyCompanyStationPrice(item)">申请调价</Button>
        </p>
      </div>
    </card>
    <!--<pageTable
                ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :showSearchForm="false"
                :tableData="tableData"
    >
    </pageTable>-->
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "indexStation",
    components:{pageTable},
    props:{
      companyId:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        searchData:{
          company_id:this.companyId,
          keyword:'',
          pagesize:500,
        },
        multiPrice:'',
        do_time:'',
        doingMultiSet:false,
        tableColumn: [
        
    
        ],
        tableData:[],
        tableTitle:'总数量:',
        loading:false,
      }
    },
    mounted(){
      this.getTableData()
      console.log(3333)
    },
    methods:{
      async getTableData(){
        let res = await this.$commonFun.postProxy('admin/company/getCompanyStation',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          this.tableData = (res.data || []).map(item=>{
            item.apply_price = item.partner_apply_status === 1 ? item.partner_apply_new_price : item.company_price
            return item
          })
        })
        return false;
        let total_page = await this.$commonFun.postProxy('admin/company/getCompanyStationPage',this.searchData)
        if(!total_page || !total_page.data || total_page.data.page<=0) return false;
        this.tableTitle = '总数量:' +  total_page.data.count
        this.loading = true
        for (let i=1;i<=total_page.data.page;i++){
          let params = this.searchData;
          params['page'] = i;
          let res = await this.$commonFun.postProxy('admin/company/getCompanyStation',params)
          this.$commonFun.dealApiResult(res,()=>{
            this.tableData = this.tableData.concat(res.data)
          })
        }
        this.loading = false
      },
      getApplyStatusColor(status){
        const map = {0:'default',1:'warning',2:'success',3:'error'}
        return map[status] || 'default'
      },
      async applyCompanyStationPrice(info){
        const applyPrice = Number(info.apply_price)
        if (!applyPrice || applyPrice <= 0){
          return this.$commonFun.errorTip('请输入正确的新价格')
        }
        if (Number(info.company_price) === applyPrice){
          return this.$commonFun.errorTip('新价格与当前价格一致')
        }
        let params = {
          company_id: this.companyId,
          station_id: info.station_id,
          apply_price: applyPrice
        }
        let res = await this.$commonFun.postProxy('admin/company/applyCompanyStationPriceAdjust',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.getTableData()
          })
        })
      },
      async editCompanyStationPrice(info){
        let params = {
          company_id: this.companyId,
          station_id:info.station_id,
          price:info.new_company_price,
          retail_prices:info.new_retail_prices
        }
        let res = await this.$commonFun.postProxy('admin/company/editCompanyStationPrice',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.getTableData()
            // this.$refs.table.resetSearchForm()
          })
        })
      },
      multiChangePrice(value){
        // this.$refs.table.tableData.forEach(item=>{
        this.tableData.forEach(item=>{
          if (item.company_price && item.company_price>0){
            item.new_company_price =value ? (parseFloat(item.price2)+parseFloat(value)).toFixed(2) : item.company_price;
            item.new_retail_prices =value ? parseFloat(parseFloat(item.retail_prices) - parseFloat(item.company_price) + parseFloat(item.new_company_price)).toFixed(2) : item.retail_prices;
          }else{
            item.new_company_price = 0;
            item.new_retail_prices = 0;
          }
        })
      },
      async multiSetPrice(){
        this.doingMultiSet = true
        // let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,price:this.multiPrice,do_time:this.do_time});
        // let data = this.$refs.table.tableData.map(item=>{
        let data = this.tableData.map(item=>{
          return {station_id:item.station_id,new_company_price:item.new_company_price,new_retail_prices:item.new_retail_prices}
        })
        let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,prices:data,do_time:this.do_time});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg)
          this.getTableData()
          // this.$refs.table.resetSearchForm()
        })
        this.doingMultiSet = false
      },
      async exportStation(){
        let res = await this.$commonFun.postProxy('admin/company/exportCompanyStation',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`${res.data.filename}.xlsx`)
        })
      },
      set_new_company_price(row,ttt){
        console.log('row0--0--',row)
        console.log('ttt---',ttt)
      }

    }
  }
</script>

<style scoped lang="less">
  .conItem{
    display: flex;
    border: 1px solid #e8eaec;
    padding: 5px;
    align-items: center;
    >p{
      margin-right: 10px;
      text-align: center;
    }
    .bianhao{
      width: 80px;
    }
    .station_id{
      width: 100px;
      >span{
        display: block;
      }
    }
    .gas_name{
      width: 120px;
      >span{
        display: block;
      }
    }
    .apply_status{
      width: 220px;
      .apply_text{
        margin-left: 8px;
      }
    }
    .apply_action{
      width: 200px;
      .editPriceInput{
        width:70px;
        margin-right: 6px;
      }
    }
    .update_time{
      width: 140px;
    }
    .price{
       width: 140px;
       >span{
         display: block;
       }
     }
    .station_price{
      width: 140px;
      >span{
        display: block;
      }
    }
    .spread_price{
      width: 100px;
    }
    .editPrice{
      flex: 1;
      .editPriceInput{
        width:60px;
        margin-right: 5px;
      }
      >span{
        display: block;
      }
    }
  }
</style>